module.exports = __webpack_public_path__ + "img/11.a40ac291.png";